exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background-color: #f9f9f9;\n}\n\n.App {\n  font-family: Arial, Helvetica, sans-serif;\n  width: 50%;\n  margin: 1em auto;\n  min-width: 500px;\n}", ""]);

// exports
